<div class="header-div">
  <div class="breadcrumbs-div">
    <nav aria-label="Breadcrumb">
      <ul class="breadcrumb">
        <li>
          <a 
            class="explore-career-link"
            routerLink="/career-matches"
            (click)="onNavigateBack()"
          >
            EXPLORE CAREERS
          </a>
        </li>
        <li aria-current="page" class="career-title">
          {{ title | uppercase }}
        </li>
      </ul>
    </nav>
    <!-- <img 
      src='/assets/icons/results/bookmark-saved-dark.svg' 
      alt="bookmark" 
      class="bookmark-icon" 
    /> -->
  </div>
  <div class="title-div">
    <h1 class="title-large">{{ title }}</h1>
    <p class="alt-names" *ngIf="alternativeNames">
      <strong>Alternative Names:</strong> {{ alternativeNames }}
    </p>
  </div>
</div>